<template>
  <div>
    <div>
      <div class="main-wrapper">
        <div>
          <!-- <layout-header2></layout-header2> -->
          <layout-header></layout-header>
          <template>
            <!-- Breadcrumb -->
            <div class="breadcrumb-bar" style="background-color: #3CB371;">
              <div class="container">
                <div class="row align-items-center">
                  <div class="col-md-12 col-12">
                    <nav aria-label="breadcrumb" class="page-breadcrumb">
                      <ol class="breadcrumb">
                        <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
                        <li class="breadcrumb-item active" aria-current="page">Update Treatment Plan</li>
                      </ol>
                    </nav>
                    <h2 class="breadcrumb-title">Update Treatment Plan</h2>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Breadcrumb -->
          </template>
          <!-- Page Content -->
          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                  <sidebar></sidebar>
                </div>
                <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                  <loader></loader>
                </div>
                <div class="col-md-7 col-lg-8 col-xl-9 doctor-profile" v-else>
                  <i class="fa fa-arrow-left fa-lg ml-md-4" aria-hidden="true"
                    style="background-color:black; color:white;padding:10px;border-radius:100%; cursor: pointer;"
                    @click="goBack"></i>
                  <!-- Basic Information -->
                  <div class="card mt-2 ml-md-4">
                    <div class="card-body doctor-profile">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label>Status</label>
                            <div class="m-1">
                              <input type="radio" value="Active" v-model="update_treatment.status" />&nbsp; Active
                              <input type="radio" value="Inactive" v-model="update_treatment.status" class="ml-5" />&nbsp;
                              Inactive
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Prescription</label>
                            <v-select class="mr-2" name="name" required="" label="template_name"
                              placeholder="Select Template" v-model="update_treatment.medical_prescription"
                              :reduce="(option) => option.name" :options="all_prescription_template">
                            </v-select>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Surgery Advice</label>
                            <v-select class="mr-2" name="name" required="" label="template_name"
                              placeholder="Select Template" v-model="update_treatment.surgery_advice"
                              :reduce="(option) => option.name" :options="all_surgery_template">
                            </v-select>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Exercise Advice</label>
                            <v-select class="mr-2" name="name" required="" label="template_name"
                              v-model="update_treatment.exercise" placeholder="Select Template"
                              :reduce="(option) => option.name" :options="all_exercise_advice_template">
                            </v-select>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Investigation Advice</label>
                            <v-select class="mr-2" name="name" required="" label="template_name"
                              v-model="update_treatment.investigation_advice" placeholder="Select Template"
                              :reduce="(option) => option.name" :options="all_investigation_template">
                            </v-select>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>General Advice</label>
                            <v-select class="mr-2" name="name" required="" label="template_name"
                              v-model="update_treatment.general_advice" placeholder="Select Template"
                              :reduce="(option) => option.name" :options="all_general_advice_template">
                            </v-select>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Description</label>
                            <textarea rows="5" type="text" class="form-control" v-model="update_treatment.description"
                              placeholder="Description" />
                          </div>
                        </div>
                        <div class="col-md-12 offset-md-12">
                          <div class="submit-section text-left">
                            <button style="height: 40px;" @click="update_update_treatment()"
                              class="btn btn-primary btn-sm mb-1">
                              Update Treatment Plan
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- /Basic Information -->
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
          <layout-footer></layout-footer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CommonApi from "../../../services/CommonApi";
import { mapState } from "vuex";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  components: {
    ckeditor: CKEditor.component,
  },
  data() {
    return {
      showspinner: false,
      disabled_template_button: true,
      disabled_new_template_button: true,
      editor: ClassicEditor,
      all_investigation_template: [],
      all_prescription_template: [],
      all_surgery_template: [],
      all_general_advice_template: [],
      all_exercise_advice_template: [],
      treatment_status: ["Active", "Inactive"],

      update_treatment: {
        treatment_plan_name: "",
        status: "Active",
        medical_prescription: "",
        surgery_advice: "",
        doctor: this.user_id,
        exercise: "",
        investigation_advice: "",
        general_advice: "",
        description: "",
      },
    };
  },
  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
    }),
  },
  watch: {
  },
  methods: {

    goBack() {
            // Go one page back
            this.$router.go(-1);
        },
    /* Get All Investigation Template Plan  */
    async get_investigation_advice_templates() {
      const params = new URLSearchParams();
      params.append("doctor", this.user_id);
      await CommonApi.get_data(
        "sahaj.template.get_investigation_advice_templates",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.all_investigation_template = res.data;
        }
      });
    },

    async get_treatment_plan() {
      const userId = this.$route.params.userId;
      await CommonApi.get_data(
        "sahaj.template.get_treatment_plan_details",
        new URLSearchParams({ name: userId })
      ).then((res) => {
        this.showspinner = false;
        this.update_treatment.treatment_plan_name =
          res.treatment_plan_name.name.template_name;
        this.update_treatment.status =
          res.treatment_plan_name.status.template_name;
        this.update_treatment.description =
          res.treatment_plan_name.description.template_name;
        this.update_treatment.name = res.treatment_plan_name.name.template_name;
        this.update_treatment.medical_prescription =
          res.treatment_plan_name.medical_prescription.template_name
        this.update_treatment.surgery_advice =
          res.treatment_plan_name.surgery_advice.template_name
        this.update_treatment.exercise =
          res.treatment_plan_name.exercise.template_name
        this.update_treatment.investigation_advice =
          res.treatment_plan_name.investigation_advice.template_name
        this.update_treatment.general_advice =
          res.treatment_plan_name.general_advice.template_name

      });
    },

    /* Get All Prescription Template Plan  */
    async get_medical_prescription_templates_list() {
      const params = new URLSearchParams();
      params.append("doctor", this.user_id);
      await CommonApi.get_data(
        "sahaj.template.get_medical_prescription_templates_list",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.all_prescription_template = res.data;
        }
      });
    },
    /* Get All Surgery Template Plan  */
    async get_surgery_advice_templates() {
      const params = new URLSearchParams();
      params.append("doctor", this.user_id);
      await CommonApi.get_data(
        "sahaj.template.get_surgery_advice_templates",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.all_surgery_template = res.data;
        }
      });
    },
    /* Get All General Advice Template Plan   */
    async get_general_advice_templates_list() {
      const params = new URLSearchParams();
      params.append("doctor", this.user_id);
      await CommonApi.get_data(
        "sahaj.template.get_general_advice_templates_list",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.all_general_advice_template = res.data;
        }
      });
    },
    /* Get All Exercise Advice Template Plan  */
    async get_exercise_templates_list() {
      const params = new URLSearchParams();
      params.append("doctor", this.user_id);
      await CommonApi.get_data(
        "sahaj.template.get_exercise_templates_list",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.all_exercise_advice_template = res.data;
        }
      });
    },
    /* Update Treatment  */
    async update_update_treatment() {
      await CommonApi.post_data(
        "sahaj.template.update_treatment_plan",
        JSON.stringify(this.update_treatment)
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          }).then(() => {
            this.$router.push("/doctor/treatment-plan");
            });
          
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },
  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if(!user){
      this.$router.push({name:'login'})
    }
    this.get_treatment_plan();
    this.get_investigation_advice_templates();
    this.get_medical_prescription_templates_list();
    this.get_surgery_advice_templates();
    this.get_general_advice_templates_list();
    this.get_exercise_templates_list();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/kneexpert/doctor/UpdateTreatmentPlan.vue